import { render, staticRenderFns } from "./SingleClientEnrolmentSuccess.vue?vue&type=template&id=1a4d644d&"
import script from "./SingleClientEnrolmentSuccess.vue?vue&type=script&lang=js&"
export * from "./SingleClientEnrolmentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SingleClientEnrolmentSuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports